Element.prototype.smsForm = () => {

    jQuery('.f-sms').validate({
        rules: {
            "ucb_nayzilam_sms_phone_number": {
                required: true,
                maxlength: 12,
                phoneUS: true
            },
        },
        messages: {
            "ucb_nayzilam_sms_phone_number": {
                "required": "Please provide a valid phone number.",
            },
        },
        errorPlacement: (error, element) => {
            error.appendTo(element.closest('.f-sms .form-item'));
        },
        errorClass: 'f-Form_Error'
    });

    jQuery('#edit-ucb-nayzilam-sms-phone-number').keyup(function(){
        jQuery(this).val(jQuery(this).val().replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3'));
    });

    function getUrlParam(name, url) {
        if (!url) url = location.href;
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        return results == null ? null : results[1];
    }

    if (document.querySelector('input[name="sms_opt_in_ruid"]')) {
        document.querySelector('input[name="sms_opt_in_ruid"]').value = getUrlParam('ruid');
    }
}

if ( document.querySelector('.f-sms') ) {
    document.querySelector('.f-sms').smsForm();
    //populateEpilepsyCookie();
}
